<style lang="less" scoped>
@import '../styles/common.less';
#chatPop{
  #setStyle{
    .ivu-date-picker .ivu-select-dropdown{
      position: absolute !important;
    }
  }
  // 咨询客服悬浮框
  .side-bar-wrapper {
    z-index: -9999;
    position: fixed;
    top: 50%;
    transform: translate(0,-50%) scale(0.9);
    right: 0;
    width: 30px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    background-color: #1d283c;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .side-bar-box {
      color: #ff9100;
      padding: 12px 4px;
      text-align: center;
      cursor: pointer;
      position: relative;
      &.notice-pop-tip {
        position: absolute;
        padding: 0;
        top: 222px;
        right: 120%;
        width: 180px;
        height: 50px;
        background: url('../images/notice-tip-bg.png') no-repeat;
        background-size: cover;
        cursor: auto;
        color: #ff9100;
        line-height: 50px;
        border-radius: 5px;
        .close-pop-tip {
          position: absolute;
          top: 3px;
          right: 12px;
          color: #48556d;
          cursor: pointer;
        }
        &:hover{
          display: block;
          background: url('../images/notice-tip-bg.png') no-repeat;
          background-size: cover;
          color: #ff9100;
        }
      }
      &:hover {
        background-color: #ff9100;
        color: #fff;
        .service-icon {
          background: url('../images/service-people-hover.png') no-repeat;
          background-size: cover;
        }
        .notice-icon {
          background: url('../images/notice-icon-pc-hover.png') no-repeat;
          background-size: cover;
        }
      }
      .service-icon {
        width: 22px;
        height: 20px;
        margin-bottom: 10px;
        background: url('../images/service-people.png') no-repeat;
        background-size: cover;
      }
      .notice-icon {
        width: 22px;
        height: 20px;
        margin-top: 10px;
        margin-bottom: 10px;
        background: url('../images/notice-icon-pc.png') no-repeat;
        background-size: cover;
      }
      .tip-flag {
        position: absolute;
        top: 12px;
        left: 3px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: red;
      }
      span {
        line-height: 1;
        font-size: 14px;
      }
      &.no-login {
        &:hover {
          .side-bar-detail-box {
            display: block;
          }
        }
      }
      .side-bar-detail-box {
        display: none;
        position: absolute;
        top: 0;
        right: 100%;
        width: 180px;
        // height: 120px;
        background-color: #48556d;
        cursor: auto;
        .side-bar-detail-item {
          padding: 15px;
          border-bottom: 1px solid #596479;
          p {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }

    }
    .message-btn {
      height: 55px;
      // background: #1992C0;
      background: #e77844;
      cursor: pointer;
      .img-box {
        position: relative;
        width: 38px;
        margin: 0 auto;
        padding-top: 14px;
        img {
          width: 100%;
        }
        span {
          position: absolute;
          top: 6px;
          right: -6px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: #fff;
          border-radius: 100%;
          background: #FF0000;
          -webkit-text-size-adjust: none;
          -webkit-transform:scale(0.8);
          -o-transform:scale(1);
          font-size: 9px;
        }
      }
    }
    .consult-service-btn {
      height: 144px;
      padding-top: 13px;
      background: #19BCFA;
      font-size: 17px;
      text-align: center;
      color: #fff;
      line-height: 1.2;
      cursor: pointer;
      img {
        width: 9px;
        margin: 8px auto 0;
      }
    }
    .notice-pop {
      width: 155px;
      height: 100px;
      position: absolute;
      top: 0;
      right: 82px;
      border: 1px solid #ccc;
      color: #fff;
      .title {
        width: 100%;
        height: 30px;
        line-height: 30px;
        padding: 0 7px;
        background: #03ADEE;
        img {
          vertical-align: middle;
          height: 24px;
          margin-right: 6px;
        }
      }
      .content {
        background: #fff;
        color: red;
        text-align: center;
        height: 68px;
        padding-top: 5px;
        span {
          font-size: 16px;
        }
      }
      .btn {
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        position: absolute;
        left: 50%;
        margin-left: -40px;
        bottom: 5px;
        background: #03ADEE;
        border-radius: 4px;
        cursor: pointer;
      }
    }
  }
  .isLogin {
    width: 30px;
    .message-btn {
      height: 44px;
      .img-box {
        width: 21px;
        img {
          width: 100%;
        }
      }
    }
    .consult-service-btn {
      height: 128px;
    }
    .notice-pop {
      right: 33px;
    }
  }
  // 客户卡片
  .card-customer {
    width: 10px;
    height:10px;
    position: fixed;
    //top:0;
    //left: 1px;
    top: 17%;
    right: -1%;
    z-index: 2;
  }
  // 咨询弹框
  .chat-pop {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    z-index: 999;
    .chat-box {
      position: fixed;
      // width: 650px;
      top: 50%;
      left: 32%; //线42，本34
      transform: translateX(-50%);
      transform: translateY(-50%);
      // z-index: 10;
      background: #fff;
      .top.box-width {
        width: 970px;
      }
      .top {
        position: absolute;
        top: -31px;
        width: 651px;
        height: 46px;
        z-index: 99;
        border-bottom: 1px solid #ccc;
        line-height: 31px;
        padding: 0 7px 0 17px;
        background: #Fff;
        border-top-right-radius: 5px;
        border-top-left-radius: 5px;
        img.v {
          vertical-align: middle;
          height: 25px;
          line-height: 48px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          line-height: 48px;
          color: #000;
        }
        div.r {
          width: 30px;
          height: 100%;
          text-align: center;
          cursor: pointer;
          font-size: 18px;
          line-height: 48px;
        }
        img.back {
          vertical-align: middle;
          display: inline-block;
          width: 8px;
          // margin-top: 8px;
        }
      }
      .content-box {
        position: relative;
      }
      .chat-list-box {
        width: 651px;
        .chat-list {
          height: 444px;
          padding: 18px 15px;
          overflow-y: scroll;
          li {
            position: relative;
            margin-bottom: 10px;
            border-radius: 5px;
            // .time {
            //     font-size: 10px;
            //     color: #999;
            //     width: 100%;
            //     text-align: center;
            // }
            .content {
              overflow: hidden;
              .type {
                height: 30px;
                line-height: 30px;
                color: #fff;
                background: #13B5B1;
              }
              img {
                height: 120px;
                max-width: 100%;
              }
            }
            .file {
              cursor: pointer;
            }
          }
          .ask {
            overflow: hidden;
            width: 100%;
            .name {
              // padding-right: 40px;
              margin-bottom: 5px;
              font-size: 10px;
              color: #999;
              width: 100%;
              text-align: right;
            }
            // img.head {
            //     width: 30px;
            //     height: 30px;
            //     border-radius: 100%;
            //     margin-left: 5px;
            // }
            // 放文字备用
            .img {
              width: 30px;
              height: 30px;
              line-height: 30px;
              border-radius: 100%;
              margin-left: 5px;
              font-size: 10px;
              color: #fff;
              background: #03ADEE;
              text-align: center;
            }
            .content {
              max-width: 500px;
              padding: 5px 7px;
              background: rgb(238, 250, 252);
              border-radius: 5px;
              font-size: 13px;
              color: #000;
            }
          }
          .replay {
            width: 100%;
            overflow: hidden;
            .name {
              // padding-left: 40px;
              margin-bottom: 5px;
              font-size: 10px;
              color: #999;
              width: 100%;
              text-align: left;
            }
            // img.head {
            //     width: 30px;
            //     height: 30px;
            //     border-radius: 100%;
            //     margin-right: 5px;
            // }
            // 放文字备用
            .img {
              width: 30px;
              height: 30px;
              line-height: 30px;
              border-radius: 100%;
              margin-right: 5px;
              font-size: 10px;
              color: #fff;
              background: #03ADEE;
              text-align: center;
            }
            .content {
              max-width: 500px;
              background: #F3F3F3;
              border-radius: 5px;
              font-size: 13px;
              .question {
                padding: 5px 9px 0;
                color: #4D4D4D;
                .cont {
                  padding: 0 5px 5px;
                  border-bottom: 1px solid #E6E6E6;
                  font-size: 12px;
                }
              }
              .img-cont {
                img {
                  height: 120px;
                }
              }
              .re-cont {
                padding: 5px 7px;
                color: #000;
              }
            }
          }
        }
        .wangEditor {
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          position: relative;
          .toolbar {
            position: relative;
            .toolBtn {
              position: absolute;
              padding: 5px;
              cursor: pointer;
              color: #999;
            }
            .uploadFileBtn {
              top: -1px;
              left: 33px;
            }
            .emoticonBtn {
              top: -1px;
              left: 61px;
            }
            .history-Btn {
              position: absolute;
              top: -1px;
              right: 20px;
              padding: 7px 5px;
              cursor: pointer;
              font-size: 12px;
              color: #999;
            }
          }
          .w-e-toolbar {
            // background: #F8FAFC;
            border-top: 1px solid #F8FAFC;
            .w-e-menu {
              padding: 5px;
              .w-e-icon-image {
                font-size: 16px !important;
              }
              i {
                font-size: 24px;
              }
            }
          }
          .w-e-text {
            padding-top: 10px;
            height: 125px !important;
            p {
              margin: 0;
            }
            img {
              max-height: 120px;
            }
          }
          .w-e-text:empty::before{
            color:red;
            content:attr(placeholder);
          }
          .emoticon-box {
            position: absolute;
            width:402px;
            height:200px;
            left:-5px;
            top:-199px;
            background-color: #fff;
            border:1px solid #000;
            box-shadow: 0 0 5px #888;
            z-index: 1;
            .emoticon-header {
              height: 30px;
              background-color: #e0e0e0;
            }
            .emoticon-item {
              width: 20px;
              height: 20px;
              float: left;
              background-image: url(../images/emoticon.jpg);
              margin: 0 5px 5px 0;
              cursor: pointer;
            }
            .emoticon-table {
              padding:15px 10px 15px 15px;
              overflow: hidden;
            }
          }
        }
      }
      .record-list-box {
        position: absolute;
        top: 14px;
        left: 650px;
        width: 320px;
        height: 602px;
        background: #fff;
        .search-box {
          padding: 10px 5px;
          text-align: right;
          border-bottom: 1px solid #F0F0F0;
          input {
            display: inline-block;
            width: 145px;
            height: 30px;
            padding-left: 30px;
            line-height: 30px;
            border-radius: 15px;
            // background: #F3F3F3;
            background: url(../images/search.png) no-repeat left 5px center #F3F3F3;
            background-size: 20px;
            border: none;
            outline:medium;
          }
        }
        .nav-bar {
          .ivu-tabs-content {
            .ivu-tabs-tabpane {
              height: 425px;
              overflow-y: scroll;
              padding: 0 16px;
              .all {
                position: relative;
                font-size: 13px;
                height: 100%;
                .record {
                  margin-bottom: 20px;
                  .time {
                    color: #999999;
                    font-size: 10px;
                    text-align: center;
                    margin-bottom: 5px;
                  }
                  .cont-box {
                    // .head {
                    //     height: 30px;
                    //     width: 30px;
                    //     border-radius: 100%;
                    //     margin-right: 5px;
                    // }
                    .content {
                      width: 237px;
                      .name.ask {
                        color: #03ADEE;
                        margin-bottom: 1px;
                        font-size: 10px;
                      }
                      .name.replay {
                        color: #808080;
                        margin-bottom: 1px;
                        font-size: 10px;
                      }
                      .cont {
                        color: #000;
                        img {
                          height: 120px;
                        }
                      }
                      .cont.file {
                        cursor: pointer;
                        .type {
                          height: 30px;
                          line-height: 30px;
                          color: #fff;
                          background: #13B5B1;
                        }
                      }
                      .cont.rep {
                        .rep-cont-box {
                          padding: 0 5px 5px;
                          border-bottom: 1px solid #E6E6E6;
                          color: #4D4D4D;
                          font-size: 12px;
                          .in-img-cont {
                            img {
                              height: 120px;
                            }
                          }
                        }
                        .img-cont {
                          color: #000;
                          img {
                            height: 120px;
                          }
                        }
                        .file {
                          cursor: pointer;
                          padding: 5px 0px;
                          .type {
                            height: 30px;
                            line-height: 30px;
                            color: #fff;
                            background: #13B5B1;
                          }
                        }
                      }
                    }
                  }
                }
              }
              .piectur-list {
                position: relative;
                .day-picture {
                  margin-bottom: 10px;
                  .time {
                    margin-bottom: 5px;
                    font-size: 16px;
                    color: #333;
                  }
                  .picture-box {
                    width: 280px;
                    overflow: hidden;
                    .picture-wrap {
                      width: 285px;
                      .picture {
                        width: 90px;
                        height: 90px;
                        margin: 0px 5px 5px 0px;
                        background: #FAFAFA;
                        overflow: hidden;
                      }
                      img {
                        width: 100%;
                        margin-top: 50%;
                        transform: translateY(-50%);
                      }
                    }
                  }
                }
              }
              .file-list {
                position: relative;
                .file-box {
                  margin-bottom: 10px;
                  .time {
                    margin-bottom: 5px;
                    font-size: 16px;
                    color: #333;
                  }
                  .file {
                    margin-bottom: 5px;
                    cursor: pointer;
                    .type {
                      width: 40px;
                      height: 40px;
                      line-height: 40px;
                      text-align: center;
                      margin-right: 5px;
                      background: #13B5B1;
                      color: #fff;
                      font-size: 13px;
                    }
                    .cont-box {
                      width: 227px;
                      height: 35px;
                      padding-top: 3px;
                      .name {
                        font-size: 12px;
                        color: #333;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      }
                      .time-name {
                        font-size: 10px;
                        color: #999999;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .page-box {
          position: absolute;
          left: 0;
          bottom: 0;
          padding: 5px 0;
          width: 100%;
          background: #F5F5F5;
          text-align: right;
          .ivu-page-simple {
            .ivu-page-prev,.ivu-page-next {
              background: #f5f5f5;
            }
          }
        }
      }
    }
    .consult-cont-pop {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 4;
      .consult-cont-box {
        position: fixed;
        top: 70px;
        left: 50%;
        transform: translateX(-50%);
        width: 530px;
        background: #fff;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
        .title {
          height: 43px;
          line-height: 43px;
          text-align: center;
          font-size: 18px;
          color: #999999;
          border-bottom: 1px solid rgba(0, 0, 0, 0.13);
          margin-bottom: 10px;
          img {
            display: inline-block;
            vertical-align: middle;
            height: 17px;
            margin-right: 5px;
          }
        }
        // 回复弹框中相关样式
        // .content {
        //     padding: 0 23px 23px;
        //     .history-msg {
        //         padding: 0 13px 13px;
        //         box-shadow: 0 0 5px #E5E5E5;
        //         max-height: 300px;
        //         overflow-y: scroll;
        //         li {
        //             border-radius: 5px;
        //             padding-top: 10px;
        //             .time {
        //                 text-align: center;
        //                 color: #CCCCCC;
        //                 font-size: 10px;
        //             }
        //             .info {
        //                 .name {
        //                     width: 35px;
        //                     height: 35px;
        //                     border-radius: 100%;
        //                     line-height: 35px;
        //                     text-align: center;
        //                     background: #F5F5F5;
        //                     color: #333;
        //                 }
        //                 .msg {
        //                     max-width: 378px;
        //                 }
        //             }
        //         }
        //         .server {
        //             .msg {
        //                 float: left;
        //                 padding: 11px;
        //                 background: #F5F5F5;
        //                 color: #333;
        //                 border-radius: 5px;
        //             }
        //             .name {
        //                 float: left;
        //                 margin-right:5px;
        //                 overflow: hidden;
        //             }
        //         }
        //         .user {
        //             .name {
        //                 float: right;
        //                 margin-left:5px;
        //                 overflow: hidden;
        //             }
        //             .msg {
        //                 float: right;
        //                 padding: 11px;
        //                 background: #03ADEE;
        //                 color: #fff;
        //                 border-radius: 5px;
        //             }
        //         }
        //     }
        //     .input-box {
        //         height: 93px;
        //         padding: 11px;
        //         box-shadow: 0 0 3px #E5E5E5;
        //         border-radius: 5px;
        //         margin-top: 10px;
        //         textarea {
        //             display: block;
        //             width: 100%;
        //             height: 100%;
        //             resize:none;
        //         }
        //     }
        //     .send-box {
        //         padding: 0 50px;
        //         margin-top: 25px;
        //         padding-bottom: 35px;
        //         Button {
        //             width: 175px;
        //             height: 48px;
        //             padding: 0;
        //             line-height: 48px;
        //             font-size: 25px;
        //         }
        //     }
        // }
      }
    }
    .emoticon-bg {
      width: 20px;
      height: 20px !important;
      background-image: url(../images/emoticon.jpg);
      cursor: auto;
      &:hover {
        box-shadow: none;
      }
    }
    img {
      display: inline;
      vertical-align: bottom;
    }
  }
  .slider-wrapper {
    position: relative;
    .carousel-part {
      width:18%;
      float:left;
      margin-top:18.5%;
    }
    .carousel-main-box {
      width: 59.9%;
      margin: 0 2.05%;
      float: left;
    };
    .demo-carousel {
      position: relative;
    }
    .notice-link {
      position: absolute;
      height: 40%;
      bottom: 0;
      left: 0;
      right: 0
    }
    .ivu-modal-content {
      background-color: rgba(0,0,0,0);
    }
    .ivu-modal-close {
      width: 33px;
      height: 33px;
      border: 2px solid rgba(255,255,255,.7);
      border-radius: 50%;
      line-height: 48px;
      right: 240px;
      top: -10px;
      .ivu-icon-ios-close-empty {
        font-size: 32px;
        color: #fff;
        top: -1px;
        &:hover {
          color: #fff;
        }
      }
    }
    .ivu-modal-footer {
      border-top: none;
    }
    .ivu-modal .ivu-modal-body {
      padding-left: 76px;
      padding-right: 76px;
      .carousel-dots {
        text-align: center;
        font-size: 18px;
        margin-top: 10px;
        font-weight: bold;
        color: #fff;
      }
    }
    .ivu-carousel {
      position: static;
      .ivu-carousel-arrow {
        width: 50px;
        height: 50px;
        top: 49%;
        .ivu-icon {
          display: none;
        }
        &.right {
          background: url(../images/right-tip.png) no-repeat;
          background-size: cover;
        }
        &.left {
          background: url(../images/left-tip.png) no-repeat;
          background-size: cover;
        }
      }
      .ivu-carousel-arrow[disabled='disabled'] {
        cursor: not-allowed;
      }
    }
  }

}


@media (max-width:1200px) {
  .slider-wrapper .ivu-modal {
    width: 100%!important;
    margin: 10px;
  }
}
</style>
<style lang="less">
.visitorModal {
  .ivu-modal-wrap {
    .ivu-modal-footer {
      display: none;
    }
  }
}
.ivu-btn {
  border: 1px solid #02CAD6;
}
.ivu-btn:hover {
  border: 1px solid #02CAD6;
}
#chatPop {
  .ivu-modal-content {
    .ivu-modal-body {
      .icon {
        color: #02CAD6;
      }
    }
    .ivu-modal-footer {
      .ivu-btn-primary {
        background-color: #02CAD6;
        border-color: #02CAD6;
      }
    }
  }
}
</style>
<template>
  <div id="chatPop" @click='bodyClick($event)'>
    <!-- 找客服侧边 -->
    <div class="side-bar-wrapper"  v-if="$store.state.showChat" :class="{'isLogin': user.id ?true :false}" :style="{'right': scrollWidth}">
      <div class="side-bar-box" :class="{'no-login': !user.id}" @click="showCharPop">
        <i class="iconfont iconkefu"></i>
        <span>联系客服</span>
        <div class="side-bar-detail-box">
          <div class="side-bar-detail-item" style="cursor: pointer;" @click="openConsultationModal">
            <Icon type="chatbubble-working" size='16' style="padding-right: 6px;"></Icon>
            <span>业务咨询</span>
          </div>
          <div class="side-bar-detail-item">
            <Icon type="ios-telephone" size='16' color="#ff9100" style="padding-right: 6px;"></Icon>
            <span>联系电话</span>
            <p>021-36622199</p>
          </div>
        </div>
      </div>
      <div class="side-bar-box"  :class="{'no-login': !user.id}" @click="showCard" >
        <i class="iconfont iconren1"></i>
        <span>鸭嘴兽联系人</span>

        <!--                <div class="side-bar-detail-box" style="text-align: left;margin-left: 5px;">-->
        <!--                    <div class="side-bar-detail-item" style="cursor: pointer;">-->
        <!--                        <i class="iconfont iconshafa" style="padding-right: 6px;"></i>-->
        <!--                        <span>老板：唐红斌</span>-->
        <!--                        <p style="text-align: center;">137-6121-9091</p>-->
        <!--                    </div>-->
        <!--                    <div class="side-bar-detail-item">-->
        <!--                        <i class="iconfont iconrenci" style="padding-right: 6px;"></i>-->
        <!--                        <span>客服总监：孙小会</span>-->
        <!--                        <p style="text-align: center;">131-2792-2603</p>-->
        <!--                    </div>-->
        <!--                </div>-->

      </div>
      <div class="side-bar-box"  :class="{'no-login': !user.id}" v-if="isCheckNotice" @click="checkNotice">
        <i class="iconfont icontongzhi"></i>
        <span>查看公告</span>
        <i v-if="!isReadFlag" class="tip-flag"></i>
        <div class="side-bar-box notice-pop-tip" style="top:20%" v-if="isShowNoticeTip">
          <div>点击这里可以查看公告啦~</div>
          <span class="close-pop-tip" @click.stop="isShowNoticeTip=false">&#10006;</span>
        </div>
      </div>

      <div class="side-bar-box" v-if="hasLogin" :class="{'no-login': !user.id}"  @click="goComplaint">
        <i class="iconfont iconjianyi"></i>
        <span>投诉与建议</span>
      </div>
      <div class="side-bar-box" :class="{'no-login': !user.id}"  @click="getManualInfo()">
        <i class="iconfont iconyewushouce"></i>
        <span>客户使用手册</span>
      </div>
      <!-- <div class="message-btn">
          <div class="img-box">
              <img src="../images/service-people.png" alt="消息">
              <span v-if="unreadNums !== 0">{{unreadNums}}</span>
          </div>
      </div>
      <div class="consult-service-btn">
          <div v-if="user.id" style="padding-bottom:20px;">找客服</div>
          <div v-else class="server" style="width: 25px; margin: 0 auto; font-size: 20px;">业务咨询</div>
          <img src="../images/back.png">
      </div> -->
      <!-- <div class="notice-pop" v-if="unreadNums !== 0">
          <div class="title">
              <img class="v" src="../images/logo.png" alt="鸭嘴兽"><span>鸭嘴兽客服-{{user.customerService}}</span>
          </div>
          <div class="content">
              <span>您有{{unreadNums}}条新消息</span>
          </div>
          <div class="btn" @click="showCharPop">
              <span>查看</span>
          </div>
      </div> -->
    </div>
    <div class="card-customer "  v-show="customerCard.show">
      <CustomerCard :show-card="customerCard.show" :has-login="hasLogin" ref="CustomerCardDom"></CustomerCard>
    </div>
    <!-- 客服聊天弹框 -->
    <div class="chat-pop" :class="{hide:chatPop}">
      <div class="chat-box">
        <div class="top" :class="{'box-width': !showChatRecord}">
          <img class="v" src="../images/touxiang.png" alt="鸭嘴兽">
          <span class="v">联系客服-
                            <span v-if="user.customerService">{{user.customerService}}</span>
                            <span v-else>智能客服</span>
                            <span v-if="customerServicePhone">( 联系电话: {{customerServicePhone}} )</span>
                            <span v-else>( 联系电话: 021-36622199 )</span>
                        </span>
          <div @click="hideChatPop" class="r">
            <!-- <img  class="back" src="../images/pop-back.png" alt="返回"> -->
            <Icon type="close" style="color: #000;"></Icon>
          </div>
        </div>
        <div class="content-box">
          <div class="chat-list-box">
            <div ref="chatList" class="chat-list" @scroll="handleReachTop">
              <ul class="clearfloat">
                <li class="clearfloat" :id="'user-question'+index" v-if="questionList.length" v-for="(msg, index) in questionList">
                  <div class="r ask" v-if="msg.judge == 0">
                    <div>
                      <div class="name">{{keepTime(msg.creationTime)}}&nbsp;&nbsp;
                        <!-- {{msg.createdByName}} -->
                        <template v-if="hasLogin">
                          {{msg.createdByName}}
                        </template>
                        <template v-else>
                          {{stranger.named ? stranger.named : stranger.mobilePhone}}
                        </template>
                      </div>
                      <div class="content-box clearfloat">
                        <!-- <img class="r head" src="../images/user.png"> -->
                        <div class="r content" v-if="msg.content && !(msg.messageType == 'FILE')" @click="showImg($event)" v-html="analysisContent(msg.content)"></div>
                        <div class="r content file" v-if="msg.messageType && msg.messageType == 'FILE'" @click="downloadFile(msg)">
                          <div class="v type">{{obtainFileType(msg.content)}}</div>
                          <div class="v">{{msg.content}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="l replay" v-else>
                    <div style="float: left">
                      <div class="name">{{msg.createdByName}}&nbsp;&nbsp;{{keepTime(msg.creationTime)}}</div>
                      <div class="content-box clearfloat">
                      </div>
                      <!-- <img class="l head" src="../images/鸭嘴兽min.png"> -->
                      <div class="l content">
                        <div class="question" v-if="msg.map.content">
                          <div class="cont">
                            <div class="name-time">{{msg.map.createdByName}}&nbsp;&nbsp;{{keepTime(msg.map.creationTime)}}</div>
                            <div class="img-cont" v-if="msg.map.content && !(msg.map.messageType == 'FILE')" @click="showImg($event)" v-html="analysisContent(msg.map.content)"></div>
                            <div class="file" v-if="msg.map.messageType && msg.map.messageType == 'FILE'" @click="downloadFile(msg.map)">
                              <div class="v type">{{obtainFileType(msg.map.content)}}</div>
                              <div class="v">{{msg.map.content}}</div>
                            </div>
                          </div>
                        </div>
                        <div
                            class="re-cont"
                            style="color:#000;"
                            v-if="msg.content && !(msg.messageType == 'FILE')"
                            @click="showImg($event)"
                            v-html="analysisContent(msg.content)">
                        </div>
                        <!-- <div class="re-cont" v-if="msg.content && !(msg.messageType == 'FILE')"  style="color:#000;" >
                            <div style="color: #ff9100; font-family: 'Songti SC';">
                                尊敬的客户</br>
                                鸭嘴兽向您赠送1000张优惠券。</br>
                                优惠券：222元优惠券。</br>
                                共计：222000元</br>
                                无规则</br>
                                有效期：2020-03-02 00:00:00-2020-03-10 23:59:59"</br>
                                <div style="display: inline-flex;color: #ff9100;cursor: pointer; margin-top: 8px;">
                                    <a href="/coupon/index" target="_blank">查看详情</a>&nbsp;&nbsp;&nbsp;
                                    <a href="/main-query-charge/index" target="_blank">立即下单</a>
                                </div>
                            </div>
                        </div> -->
                        <div class="l file" style="padding:5px 7px;" v-if="msg.messageType && msg.messageType == 'FILE'" @click="downloadFile(msg)">
                          <div class="v type">{{obtainFileType(msg.content)}}</div>
                          <div class="v">{{msg.content}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="wangEditor">
              <div v-if='showEmoticon' class="emoticon-box">
                <!-- <div class="emoticon-header"></div> -->
                <ul class="emoticon-table">
                  <li v-for='(v,k) in emoticonsList' :title='k' @click='addEmoticon(k)' :class="v" class="emoticon-item"></li>
                </ul>
              </div>
              <div :id="'edit-bar-' + openpage" class="toolbar">
                <div class="uploadFileBtn toolBtn">
                  <Upload
                      ref="upload"
                      :headers="headersObj"
                      :format="['doc','docx','xls','xlsx','pptx','pdf','zip','rar']"
                      :multiple="false"
                      :data="uploadInfo"
                      :before-upload="handleUpload"
                      :show-upload-list="false"
                      :on-format-error="formatError"
                      :on-success="uploadSuccess"
                      action="/ws-truck/messenger/upload/file"
                  >
                    <Icon type="ios-folder" size="20"></Icon>
                  </Upload>
                </div>
                <!-- <div class="emoticonBtn toolBtn" @click='showEmoticon = !showEmoticon'>
                    <Icon type="android-happy" size="20" />
                </div> -->
                <div @click="lookHistoryRecord" class="history-Btn" v-if="user.id">
                  历史消息
                </div>
              </div>
              <div :id="'edit-cont-' + openpage" style="text-align:left;" @keydown.enter='getContent($event)'></div>
              <div style="padding:10px;overflow: hidden;">
                <!-- <Button v-on:click="complaintModal.fade = true" type="primary" style="display:inline-block;float: left;">我要投诉</Button> -->
                <!-- <a @click="goComplaint" style="line-height: 30px; font-size: 14px; text-decoration: underline;">我要投诉</a> -->
                <Button v-on:click="getContent()" type="primary" style="display:inline-block;float: right;background-color: #02CAD6;border-color: #02CAD6">发送</Button>
              </div>
            </div>
          </div>
          <!-- 历史聊天消息记录 -->
          <div class="record-list-box" :class="{'hide': showChatRecord}">
            <div class="search-box">
              <input type="text" v-model.trim="searchInput" v-on:keyup.enter="getHistoryRecord('search')">
            </div>
            <div class="nav-bar">
              <Tabs :value="curTabActive" :animated="false" @on-click="clickTab($event)" size="small">
                <!-- 全部消息 -->
                <TabPane label="全部" name="all">
                  <div class="all">
                    <div class="record" v-if="histyQuestionList.length" v-for="(info, index) in histyQuestionList">
                      <!-- <div class="time">{{info.creationTime}}</div> -->
                      <div class="cont-box clearfloat" v-if="info.parentId == 0">
                        <!-- <img class="l head" src="../images/user.png" > -->
                        <div class="l content">
                          <div>
                            <div class="name ask">{{info.createdByName}}&nbsp;&nbsp;{{keepTime(info.creationTime)}}</div>
                            <div class="cont" v-if="info.content && !(info.messageType == 'FILE')" @click="showImg($event)" v-html="analysisContent(info.content)"></div>
                            <div class="cont file" v-if="info.messageType && info.messageType == 'FILE'" @click="downloadFile(info)">
                              <div class="v type">{{obtainFileType(info.content)}}</div>
                              <div class="v">{{info.content}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="cont-box clearfloat" v-else>
                        <!-- <img class="l head" src="../images/鸭嘴兽min.png" > -->
                        <div class="l content">
                          <div class="name replay">{{info.createdByName}}&nbsp;&nbsp;{{keepTime(info.creationTime)}}</div>
                          <div class="cont rep">
                            <div class="rep-cont-box">
                              <div>{{info.map.createdByName}}&nbsp;&nbsp;{{keepTime(info.map.creationTime)}}</div>
                              <div class="in-img-cont" v-if="info.map.content && !(info.map.messageType == 'FILE')" @click="showImg($event)" v-html="analysisContent(info.map.content)"></div>
                              <div class="file" style="padding:0;" v-if="info.map.messageType && info.map.messageType == 'FILE'" @click="downloadFile(info.map)">
                                <div class="v type">{{obtainFileType(info.map.content)}}</div>
                                <div class="v">{{info.map.content}}</div>
                              </div>
                            </div>
                            <div class="img-cont" v-if="info.content && !(info.messageType == 'FILE')" @click="showImg($event)" v-html="analysisContent(info.content)"></div>
                            <div class="file" v-if="info.messageType && info.messageType == 'FILE'" @click="downloadFile(info)">
                              <div class="v type">{{obtainFileType(info.content)}}</div>
                              <div class="v">{{info.content}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Spin size="large" fix v-if="allLoader"></Spin>
                  </div>
                </TabPane>
                <TabPane label="图片" name="picture">
                  <div class="piectur-list">
                    <div class="day-picture" v-if="histyPictureList.length" v-for="(item, index) in histyPictureList">
                      <div class="time">{{handleTimeFormat(item[0].date)}}</div>
                      <div class="picture-box">
                        <div class="picture-wrap clearfloat">
                          <div class="l picture" v-if="item.length" v-for="picture in item">
                            <img @click="showImg($event)" class="l" :src="picture.filePath">
                          </div>
                        </div>
                      </div>
                    </div>
                    <Spin size="large" fix v-if="allLoader"></Spin>
                  </div>
                </TabPane>
                <TabPane label="文件" name="file">
                  <div class="file-list">
                    <div class="file-box" v-if="histyFileList.length" v-for="item in histyFileList">
                      <div class="time">{{handleTimeFormat(item[0].date)}}</div>
                      <div class="file clearfloat" v-if="item.length" v-for="file in item"  @click="downloadFile(file)">
                        <div class="type l">{{obtainFileType(file.content)}}</div>
                        <div class="cont-box l">
                          <div class="name" :title="file.content">{{file.content}}</div>
                          <div class="time-name">{{file.time}}&nbsp;&nbsp;{{file.createdByName}}</div>
                        </div>
                      </div>
                    </div>
                    <Spin size="large" fix v-if="allLoader"></Spin>
                  </div>
                </TabPane>
              </Tabs>
              <div id="setStyle">
                <DatePicker
                    style="position: absolute;top: 60px;right: 15px;"
                    :open="open"
                    :value="sarchDate"
                    confirm
                    type="date"
                    placement="bottom-end"
                    @on-change="serarchDateChange"
                    @on-clear="serarchDateClear"
                    @on-ok="serarchDateOk">
                  <a @blur="serarchBlur" href="javascript:void(0)" @click="serarchDateClick">
                    <Icon size="16" type="ios-calendar-outline"></Icon>
                    <template v-if="sarchDate === ''"></template>
                    <template v-else>{{ sarchDate }}</template>
                  </a>
                </DatePicker>
              </div>
            </div>
            <div class="page-box">
              <Page :current="historyPage.curPage" :total="historyPage.total" simple @on-change="getPage($event)"></Page>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--查看聊天记录中的图片-->
    <Modal  :closable="false" v-model="lookPictureModel" width="757px" :styles="{top: '20px'}">
      <div class="look-picture">
        <image-viewer :styleObjs="imageViewerParams.styles" :images="imageViewerParams.recordImgs"></image-viewer>
      </div>
      <div slot="footer">
        <Button type="primary" @click="lookPictureModel = false">关闭</Button>
      </div>
    </Modal>
    <!--业务咨询弹窗-->
    <consultation-modal :fade='isConsultationModalVisible' @change='isConsultationModalVisible = false'></consultation-modal>
    <complaint-modal :fade='complaintModal.fade' @change="complaintModal.fade = false"></complaint-modal>
    <!-- 公告展示 -->
    <transition name="fade" mode="in-out">
      <Modal v-show='noticeModal.fade' v-model="noticeModal.fade" width="1200" style="text-align: center;" class="slider-wrapper" :mask-closable="false" :footer-hide="true" @on-cancel="cancelImgModal">
        <div class="carousel-cover">
          <div class="carousel-part carousel-part-lf">
            <img
                v-if="noticeModal.noticeSetting.lfImg"
                :src="noticeModal.noticeSetting.lfImg"
                class="slide-lf" alt=""
                style="width:100%"
                @click="moveLeft">
            <img
                v-else
                src="../images/default-img.png"
                class="slide-lf"
                style="width:100%"
                @click="moveLeft">
          </div>
          <div class="carousel-main-box">
            <Carousel
                v-model="noticeModal.noticeSetting.index"
                :arrow="noticeModal.noticeSetting.arrow"
                :dots="noticeModal.noticeSetting.dots"
                v-if="noticeModal.fade"
                @on-change="changeNotice">
              <CarouselItem
                  v-for="(item,index) in noticeModal.noticeSetting.data"
                  :key="index">
                <div class="demo-carousel">
                  <img v-if='item.url' :src="item.url" alt="" style="width:100%">
                  <img v-else src="../images/default-img.png" alt="" style="width:100%">
                  <a @click="openNewPage($event,item.link)" class="notice-link"></a>
                </div>
              </CarouselItem>
            </Carousel>
          </div>
          <div class="carousel-part carousel-part-rt">
            <img
                @click="moveRight"
                v-if="noticeModal.noticeSetting.rtImg"
                :src="noticeModal.noticeSetting.rtImg"
                class="slide-rt"
                alt=""
                style="width:100%">
            <img
                @click="moveRight"
                v-else src="../images/default-img.png"
                class="slide-rt"
                alt=""
                style="width:100%">
          </div>
          <div style="clear:both"></div>
        </div>
        <div class="carousel-dots">{{noticeModal.noticeSetting.index+1}}/{{noticeModal.noticeSetting.data.length}}</div>
      </Modal>
    </transition>
    <Modal v-model="manual.show" width="750" title="客户手册" :footer="null">
      <iframe :src="manual.info" width="100%"  height="600" frameborder="0"></iframe>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="visitorModal" title="联系客服" class="visitorModal" width="400">
      <Form
          class="login-form"
          ref="mobileForm"
          style="width: 100%;margin: 0 auto;"
          :model="mobileForm"
          :rules="mobileFormRules"
      >
        <FormItem prop="named" label="称谓：" :label-width="80">
          <Input
              type="text"
              v-model="mobileForm.named"
              placeholder="请输入称谓"
          ></Input>
        </FormItem>
        <FormItem prop="mobilePhone" label="手机号：" :label-width="80">
          <Input
              type="text"
              v-model="mobileForm.mobilePhone"
              placeholder="请输入手机号"
          >
            <Button
                slot="append"
                @click='getCode'
                :loading="codeLoading"
            >
                      <span
                          v-if='codeLoading'
                          @click='getCode'
                      >({{codeLoadingCount}})重新发送</span>
              <span v-else>获取验证码</span>
            </Button>
          </Input>
        </FormItem>
        <vcode
            ref="vcode"
            @finished="sentVcode"
            templetCode="SUPPORT-CAPTCHA"
            mateCode="HARBOUR"
            :showIcon="false"
        ></vcode>
        <FormItem prop="code" label="验证码：" :label-width="80">
          <Input
              v-model="mobileForm.code"
              placeholder="请输入验证码"
          ></Input>
        </FormItem>
        <Button
            class="login-btn"
            style="background: #02CAD6;color: #fff;"
            long
            :loading="loginLoading"
            @click="handleSubmit('mobileForm')"
        >
          <span>确定</span>
        </Button>
      </Form>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import axios from 'axios';
import util from '../libs/util';
import E from '../libs/wangEditor' // 自定义修改过的
import imageViewer from '../components/image-viewer';
import scrollBar from '../components/scroll-bar';
import $ from 'jquery';
import consultationModal from './consultation-modal';
import complaintModal from './customer-complaint';
import { encrypt, decode } from "@/libs/encrypt-and-decode.js"
import CustomerCard from "@/components/customer-card"
import vcode from '@/components/vcode'
import dayjs from 'dayjs'
import win from 'global';
import { log } from 'video.js';
export default {
  props: {
    openpage: {
      type: String | Number,
      default: true,
    },
    onClose: {
      type: Function,
      default: () => {},
    },
  },
  components: {
    CustomerCard,
    'image-viewer': imageViewer,
    'scroll-bar': scrollBar,
    'consultation-modal': consultationModal,
    'complaint-modal': complaintModal,
    vcode
  },
  data: () => {
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!/^[1-9][0-9]{10}$/.test(value)) {
        callback(new Error('请输入正确手机号'))
      } else {
        callback()
      }
    }
    return {
      firstContent: '',
      stranger: {mobilePhone: '',named: ''},
      mobileForm: {
        mobilePhone: '',
        code: '',
        named: ''
      },
      codeLoading: false,
      codeLoadingCount: '',
      mobileFormRules: {
        mobilePhone: {
          required: true,
          validator: validatePhone,
          trigger: 'blur',
        },
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur',
          },
        ],
      },
      loginLoading: false,
      visitorModal: false,
      chooseContactModal: false,
      customerServicePhone:'021-36622199',
      user:{
        id: Cookies.get("user") ? decode(Cookies.get("user")) : Cookies.get("user")
      },
      open: false, //搜索日期
      sarchDate: "", //聊天记录搜索日期
      //业务咨询
      isConsultationModalVisible: false,
      // <--关于通讯
      showChat:null,
      isCreateEditor:false,
      lookPictureModel: false,
      // image-viewer控件传参
      imageViewerParams: {
        styles: {},
        recordImgs: []
      },
      // editorContent: '',
      uploadInfo: {
        // file: '',
        fileName: '',
        fileType: ''
      },
      headersObj: {
        'X-Requested-By': 'eshipping'
      },
      // 弹框
      chatPop: true,
      consultContPop: true,
      questionContent: '',
      questionList: [],
      questionListTotal: 0,
      // webSocket拿到的消息总数
      socketQuestionTotal: 0,
      // 上翻页是否加载
      isTurePage: true,
      // 获取聊天消息请求条件
      questionListReq: {
        page: 1,
        pageSize: 30
      },
      recordList: {},
      replayMsgCont: '',
      editor: {},
      // 未读消息数
      unreadNums: 0,
      // 上划时的页码
      topCurPage: 1,
      // 聊天历史记录
      historyReq: {
        page: 1,
        pageSize: 10
      },
      historyPage: {
        curPage: 1,
        total: 0
      },
      // 历史消息列表
      histyQuestionList: [],
      // 搜索框内容
      searchInput: '',
      // 图片列表
      histyPictureList: [],
      // 文件列表
      histyFileList: [],
      // 当前tab高亮项
      curTabActive: 'all',
      allLoader: false,
      // 聊天记录的显示
      showChatRecord: true,
      // 表情的显示
      showEmoticon: false,
      // 表情key列表
      emoticonsList: {
        '[笑脸]': 'emoticon_xiaolian',
        '[大笑]': 'emoticon_daxiao',
        '[酷]': 'emoticon_ku',
        '[微笑]': 'emoticon_weixiao',
        '[眨眼]': 'emoticon_zhayan',
        '[色]': 'emoticon_se',
        '[飞吻]': 'emoticon_feiwen',
        '[亲亲]': 'emoticon_qinqin',
        '[害羞]': 'emoticon_haixiu',
        '[满意]': 'emoticon_manyi',
        '[露齿笑]': 'emoticon_luchixioa',
        '[戏弄]': 'emoticon_xinong',
        '[调皮]': 'emoticon_tiaopi',
        '[馋]': 'emoticon_chan',
        '[得意]': 'emoticon_diyi',
        '[鄙视]': 'emoticon_bishi',
        '[汗]': 'emoticon_han',
        '[失望]': 'emoticon_shiwang',
        '[低落]': 'emoticon_diluo',
        '[呸]': 'emoticon_pei',
        '[焦虑]': 'emoticon_jiaolv',
        '[担心]': 'emoticon_danxin',
        '[震惊]': 'emoticon_zhenjing',
        '[悔恨]': 'emoticon_huihen',
        '[白眼]': 'emoticon_baiyan',
        '[大哭]': 'emoticon_daku',
        '[笑哭]': 'emoticon_xiaoku',
        '[闭嘴]': 'emoticon_bizui',
        '[思考]': 'emoticon_sikao',
        '[惊讶]': 'emoticon_jingya',
        '[吐钱]': 'emoticon_tuqian',
        '[生气]': 'emoticon_shengqi',
        '[惊恐]': 'emoticon_jingkong',
        '[生气2]': 'emoticon_shengqi2',
        '[气愤]': 'emoticon_qifen',
        '[犯困]': 'emoticon_fankun',
        '[生病]': 'emoticon_shengbing',
        '[恶魔]': 'emoticon_emo',
        '[花]': 'emoticon_hua',
        '[太阳]': 'emoticon_taiyang',
        '[月亮]': 'emoticon_yueliang',
        '[星星]': 'emoticon_xingxing',
        '[西瓜]': 'emoticon_xigua',
        '[啤酒]': 'emoticon_pijiu',
        '[撒花]': 'emoticon_sahua',
        '[红心]': 'emoticon_hongxin',
        '[心碎]': 'emoticon_xinsui',
        '[丘比特]': 'emoticon_qiubite',
        '[铃铛]': 'emoticon_lingdang',
        '[喇叭]': 'emoticon_laba',
        '[礼物]': 'emoticon_liwu',
        '[钱]': 'emoticon_qian',
        '[吹气]': 'emoticon_chuiqi',
        '[雨滴]': 'emoticon_yudi',
        '[多云]': 'emoticon_duoyun',
        '[下雨]': 'emoticon_xiayu',
        '[火]': 'emoticon_huo',
        '[握手]': 'emoticon_woshou',
        '[赞]': 'emoticon_zan',
        '[弱]': 'emoticon_ruo',
        '[好的]': 'emoticon_haode',
        '[拳头]': 'emoticon_quantou',
        '[拳头2]': 'emoticon_quantou2',
        '[耶]': 'emoticon_ye',
        '[向上]': 'emoticon_xiangshang',
        '[向下]': 'emoticon_xiangxia',
        '[向右]': 'emoticon_xiangyou',
        '[向左]': 'emoticon_xiangzuo',
        '[手指]': 'emoticon_shouzhi',
        '[双手]': 'emoticon_shuangshou',
        '[鼓掌]': 'emoticon_guzhang',
        '[拜托]': 'emoticon_baituo',
        '[加油]': 'emoticon_jiayou',
        '[写字]': 'emoticon_xiezi',
        '[日历]': 'emoticon_rili',
        '[邮件]': 'emoticon_youjian',
        '[钻石]': 'emoticon_zuanshi',
        '[闹钟]': 'emoticon_naozhong',
        '[上锁]': 'emoticon_shangsuo',
        '[开锁]': 'emoticon_kaisuo',
        '[车]': 'emoticon_che',
        '[信号灯]': 'emoticon_xinhaodeng',
        '[路障]': 'emoticon_luzhang',
        '[港口]': 'emoticon_gangkou',
        '[船]': 'emoticon_chuan',
        '[火箭]': 'emoticon_huojian',
        '[炸弹]': 'emoticon_zhadan',
        '[厕所]': 'emoticon_cesuo',
        '[停车]': 'emoticon_tingche',
        '[拍照]': 'emoticon_paizhao',
        '[禁烟]': 'emoticon_jinyan',
        '[禁]': 'emoticon_jin',
        '[禁止]': 'emoticon_jinzhi',
        '[禁止2]': 'emoticon_jinzhi2',
        '[错误]': 'emoticon_cuowu',
        '[感叹]': 'emoticon_gantan',
        '[双叹]': 'emoticon_shuangtan',
        '[问号]': 'emoticon_wenhao',
        '[疑问]': 'emoticon_yiwen',
        '[警告]': 'emoticon_jinggao',
        '[满分]': 'emoticon_manfen',
        '[祝福]': 'emoticon_zhufu',
        '[Mac]': 'emoticon_Mac',
        '[Wac]': 'emoticon_Wac',
        '[警察]': 'emoticon_jingcha',
      },
      scrollWidth: 0,
      sideBarHeight: 0,
      // 关于通讯-->
      complaintModal: {
        fade: false
      },
      hasLogin: Cookies.get('user') || false,
      isCheckNotice: false, // 查看公告
      isShowNoticeTip: false, // 气泡提示公告
      noticeModal: {
        fade: false,
        noticeSetting: {
          index: 0,
          arrow: 'always',
          dots: 'none',
          data: [],
          rtImg: '',
          lfImg: ''
        }
      },
      noticeData: '', //弹窗的显示的内容传参
      isReqNotice: true,
      isReadFlag: true,
      manual:{
        show:false,
        info:null
      },
      customerCard: {
        show: false,
        info:null
      }
    }
  },
  mounted(){
    this.isCreateEditor = true;
    this.getStranger()
    this.getCurrentUser()
    this.initEmoticonStyle()
    this.initScrollWidth()
//			 this.getChatList()
    // this.getManualInfo()
  },
  computed:{
    websocketurl () {
      // var url = ''
      // if(window.location.origin.indexOf('qa')>0){
      //     url ='wss://qa.new.carrierglobe.com/websocket'
      // }else{
      //     url = 'wss://new.carrierglobe.com/websocket'
      // }
      // return url
      return 'wss://' + window.location.host + '/websocket'
    }
  },
  watch: {
    $route(to,from) {
      this.$nextTick(function(){
        this.noticeData = ''
        if($('#home-link').length !=0) {
          this.noticeData = 'PC_ORDER_CENTER'
        }else {
          this.noticeData = 'PC_INDEX'
        }
        this.showNotice(this.noticeData)
      })
      this.initScrollWidth()
    }
  },
  methods:{
    getStranger() {
      this.stranger = JSON.parse(window.sessionStorage.getItem('stranger'))
      this.stranger ? this.getChatList() : null
    },
    handleSubmit() {
      console.log(this.mobileForm);
      window.sessionStorage.removeItem('stranger')
      this.stranger = {mobilePhone: '',named: ''}
      // window.sessionStorage.setItem('stranger', JSON.stringify(this.mobileForm))
      // this.getStranger()
      this.$refs.mobileForm.validate(valid => {
        if (valid) {
          util.ajax_get(this,'/ws-truck/duckBill/valid/customer/registration/code',this.mobileForm, res => {
            console.log(res);
            if (res.data.success) {
              this.mobileForm.sendCode = JSON.parse(res.data.data.value)
              window.sessionStorage.setItem('stranger', JSON.stringify(this.mobileForm))
              this.getStranger()
              // this.showCharPop()
              this.getCurrentUser()
              this.visitorModal = false
              this.autoReply('WELCOME')
              // this.getContent()
            } else {
              this.$Message.error(res.data.message)
              window.sessionStorage.removeItem('stranger')
              this.stranger = {mobilePhone: '',named: ''}
            }
          },err => {
            console.log(err);
            window.sessionStorage.removeItem('stranger')
            this.stranger = {mobilePhone: '',named: ''}
            // this.getCurrentUser()
          })
        }
      })

    },
    // 获取验证码
    getCode() {
      this.$refs.mobileForm.validateField('mobilePhone', (err) => {
        if (!err) {
          this.$refs['vcode'].show(this.mobileForm.mobilePhone)
        }
      })
    },
    sentVcode(data) {
      this.mobileForm.token = data.token
      this.mobileForm.platform = 'client'
      this.codeLoading = true
      this.codeLoadingCount = 60
      let countTimer = setInterval(() => {
        if (--this.codeLoadingCount == 0) {
          clearInterval(countTimer)
          this.codeLoading = false
        }
      }, 1000)
    },
    getManualInfo(){
      if (!this.manual.info) {
        util.ajax_get(this, '/ws-truck/customer/manual',{}, res => {
          if (res.data.success) {
            this.manual.info = res.data.data.value.replace(/^(\s|")+|(\s|")+$/g, '')
            this.manual.show = true
          }
        })
      } else {
        this.manual.show = true
      }
    },
    baiduTongji(name) {
      _hmt.push(['_trackEvent', 'PC-首页', 'PC-首页-'+name, Cookies.get("user") ?`用户名:${Cookies.get('user')}` :'未登录'])
    },
    //我要投诉
    goComplaint: function() {
      _hmt.push(['_trackEvent', '用户已登录', 'click', '我要投诉'])
      this.complaintModal.fade = true
    },
    initScrollWidth() {
      let timer = setInterval(() => {
        if(!document.getElementById('main')) return
        if (this.user.id) {
          this.scrollWidth = '-45px'
        } else {
          this.scrollWidth = '-45px'
          // this.scrollWidth = (window.innerWidth - document.getElementById('main').clientWidth) + 'px'
        }
        this.sideBarHeight = window.innerHeight - 100 + 'px'
        clearInterval(timer)
      }, 100)
    },
    initEmoticonStyle() {
      let inlinecss = '',
          count = -1,
          lineNum = 15

      for(let k in this.emoticonsList){
        let x = 1-parseInt(++count%lineNum)*30
        let y = 0-parseInt(count/lineNum)*30
        inlinecss += '.' + this.emoticonsList[k] + ' {background-position: ' + x + 'px ' + y + 'px;}'
      }

      let style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = inlinecss;
      document.getElementsByTagName('HEAD').item(0).appendChild(style);
    },
    bodyClick(e) {
      if(this.showEmoticon == false) return
      let className = e.target.className
      if(className.indexOf('emoticon-table') != -1 || className.indexOf('emoticon-item') != -1 || className.indexOf('ivu-icon-android-happy') != -1) return
      this.showEmoticon = false
    },
    serarchDateClick () {
      this.open = !this.open;
    },
    serarchDateChange (date) {
      this.sarchDate = date;
      this.serarchDateOk()
      this.clickTab(this.curTabActive)
      this.historyReq.page = 1

      $('.ivu-tabs-tabpane').scrollTop(0);

    },
    serarchDateClear () {
      this.open = false;
    },
    serarchDateOk () {
      this.open = false;
    },
    serarchBlur () {
      this.open = false;
    },
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      this.sarchDate = currentdate
    },
    // 获取客服手机号
    queryPhoneByUserName(userName){
      util.ajax_post(this, '/ws-truck/duckBill/user/queryPhoneByUserName',{
        userName:userName
      }, res => {
        if (res.data.success) {
          this.customerServicePhone = JSON.parse(res.data.data.value)
        }
      })
    },
    // 获取当前用户信息
    getCurrentUser() {
      util.ajax_get(this, '/ws-truck/user/current', Date.now(), response => {
        if (response.data.success && response.data.user.companyName) {
          this.user = response.data.user;
          this.queryPhoneByUserName(response.data.user.customerService)
          // 建立连接
          this.linkGoeasy();
          // 获取消息列表
          this.getChatList();
          window.sessionStorage.removeItem('stranger')
        } else if (this.stranger) {
          this.user.userName =  this.stranger.mobilePhone
          // 建立连接
          // this.linkGoeasy();
          // 获取消息列表
          this.getChatList();
          // this.showCharPop()
        } else {
          this.user = {};
          this.toIndex();
        }
      });
    },
    // <--聊天
    // 创建 websocket 连接
    linkGoeasy() {
      var that = this;
      if (!that.user.userName) return;

      this.goEasy.connect({
        onSuccess: function () { //连接成功
          console.log("goeasy连接成拉！！！！") //连接成功
        },
        onFailed: function (error) { //连接失败
          console.log("goeasy连接失败",error)
        }
      });
      var condition = this.questionListReq;
      that.stranger ? condition.phone = that.stranger.mobilePhone : null
      var pubsub = this.goEasy.pubsub;
      pubsub.subscribe({
          channel: this.user.userName,//替换为您自己的channel
          onMessage: function (message) {
              //收到消息
              console.log("goeasy收到消息！",message)
              if (message.content && message.content == "true" && !that.chatPop) {
                that.getChatList();
                console.log('聊天框显示时，questionList', that.questionList);
              }
              else if (message.content && message.content == "true") {
                console.log('聊天框隐藏时')
                var curQuestionList = util.deepClone(that.questionList);
                util.ajax_get(that, '/ws-truck/messenger/customer/posting/record', condition, response => {
                  if (response.data.success) {
                    response = eval('('+response.data.data.value+')');
                    that.questionList = response.list;
      //                      console.log('curQuestiontotal', response.total);
      //                      console.log('queslisttotal', that.questionListTotal);
                    that.unreadNums =  response.total - that.questionListTotal;
                    that.socketQuestionTotal = response.total;
                    that.$Notice.destroy()
                    that.$Notice.info({
                      title: `您有${that.unreadNums}条新消息`,
                      duration: 0,
                      render: h => {
                        return h('a', {
                          domProps: {
                            innerHTML: "点击查看"
                          },
                          on: {
                            click() {
                              that.showCharPop()
                              that.$Notice.destroy()
                            }
                          }
                        })
                      }
                    });
                  }
                });
              }
          },
          onSuccess: function () {
              console.log("Channel订阅成功。");
          },
          onFailed: function (error) {
              console.log("Channel订阅失败, 错误编码：" + error.code + " 错误信息：" + error.content)
          }
      });

      console.log('that.user',that.user);
      // debugger;
      // if (!that.user.userName) return;
      // 连开发
      // that.webSocketCtro = new WebSocket('ws://192.168.30.71:8080/websocket');
      // 上线时连下条
      // that.webSocketCtro = new WebSocket(this.websocketurl);
      // 连qa
      // that.webSocketCtro = new WebSocket('ws://qa.new.carrierglobe.com/websocket');

      // that.webSocketCtro.onopen = function (evt) {
      //   var obj = {};
      //   obj.messageType = 'reg';
      //   obj.userId = that.user.userName;
      //   var sendJSONStr = JSON.stringify(obj);
        // debugger
      //   that.webSocketCtro.send(sendJSONStr);
      // }
      // setInterval(() => {
      //   that.webSocketCtro = new WebSocket(this.websocketurl);
      // },600000)
      // var condition = this.questionListReq;
      // that.stranger ? condition.phone = that.stranger.mobilePhone : null
//       that.webSocketCtro.onmessage = function (evt) {
//         if (evt.data && evt.data == "true" && !that.chatPop) {
//           that.getChatList();
//           console.log('聊天框显示时，questionList', that.questionList);
//         }
//         else if (evt.data && evt.data == "true") {
//           console.log('聊天框隐藏时')
//           var curQuestionList = util.deepClone(that.questionList);
//           util.ajax_get(that, '/ws-truck/messenger/customer/posting/record', condition, response => {
//             if (response.data.success) {
//               response = eval('('+response.data.data.value+')');
//               that.questionList = response.list;
// //                      console.log('curQuestiontotal', response.total);
// //                      console.log('queslisttotal', that.questionListTotal);
//               that.unreadNums =  response.total - that.questionListTotal;
//               that.socketQuestionTotal = response.total;
//               that.$Notice.destroy()
//               that.$Notice.info({
//                 title: `您有${that.unreadNums}条新消息`,
//                 duration: 0,
//                 render: h => {
//                   return h('a', {
//                     domProps: {
//                       innerHTML: "点击查看"
//                     },
//                     on: {
//                       click() {
//                         that.showCharPop()
//                         that.$Notice.destroy()
//                       }
//                     }
//                   })
//                 }
//               });
//             }
//           });
//         }
//         console.log('连接成功', evt);
//       }
      // that.webSocketCtro.onclose = function (evt) {
      //   console.log('连接关闭',evt)
      // };
      // that.webSocketCtro.onerror = function (evt) {
      //   console.log('连接错误', evt)
      // };
    },
    // 获取聊天列表
    getChatList() {
      var condition = this.questionListReq;
      // 获取当前用户id
      var userId = this.user.userName;
      this.stranger ? condition.phone = this.stranger.mobilePhone : null
      // this.stranger ? this.showCharPop() : null
      console.log('kkk',condition)
      util.ajax_get(this, '/ws-truck/messenger/customer/posting/record', condition, response => {
        if (response.data.success) {
          response = eval('('+response.data.data.value+')');

          console.log('接收到的消息列表', response)
          this.questionList = response.list;
          this.questionListTotal = response.total;
          // 初始化向上滑动分页
          this.topCurPage = 1;
//              console.log('list', this.questionList);
          this.$nextTick(function () {
            if(this.questionList.length) {
              if (this.$refs.chatList){
                var div = this.$refs.chatList;
                  div.scrollTop = div.scrollHeight;
              }
            }
          })
        }
      });
    },
    // 调整等待时间格式
    getTimeFormat(h,m,s) {
      if (h && h<10) {
        h = '0'+h;
      }
      if (m && m<10) {
        m = '0'+m;
      }
      if (s && s<10) {
        s = '0'+s;
      }
      if (!h) {
        h = '00';
      }
      if (!m) {
        m = '00';
      }
      if (!s) {
        s = '00';
      }
      var time = h + ":" + m + ":" + s;
      return time;
    },
    // 服务咨询
    consultService() {
      this.openConsultationModal()
    },
    directContact() {
      this.chooseContactModal = false
      this.visitorModal = true
    },
    // 判断是否登录然后联系客服
    judgeUser() {
      if (!this.user.id) {
        this.showCharPop()
        // if (this.stranger) {

        // } else {
        //     this.visitorModal = true
        // }
        // this.chooseContactModal = true
        // this.$Message.error('请先登录');
        // this.$router.push({
        //     path: "login"
        // })
        return;

      } else {
        this.showCharPop()
      }
    },
    // 联系客服
    showCharPop() {
      // if (!this.user.id) {
      //     // this.$Message.error('请先登录');
      //     // this.$router.push({
      //     //     path: "login"
      //     // })
      //     // return;
      // }
      // 如果有未读消息数则置为0
      if (this.unreadNums) {
        this.unreadNums = 0;
      }
      // 如果有从websocket拿到的消息总数
      if (this.socketQuestionTotal) {
        this.questionListTotal = this.socketQuestionTotal;
      }
      console.log('questionListTotal',this.questionListTotal);
      if (this.questionListTotal == 0) {
        this.questionList = []
        // this.autoReply('welcome')
        console.log('没有消息');
        let welcome = {
          "content": "{p}尊敬的客户，您好！我是鸭嘴兽客服，很高兴为您服务。{/p}",
          "createdBy": "liuxin",
          "createdByName": "鸭嘴兽智能客服",
          "creationTime": dayjs(new Date()).format('YYYY-MM-DD hh:mm:ss'),
          "filePath": "",
          "id": 91570,
          "judge": 1,
          "map": {},
          "messageType": "",
          "parentId": 0
        }
        this.questionList.push(welcome)
      }
      this.chatPop = false;
      this.isConsultationModalVisible = false
      // _hmt.push(['_trackEvent', '用户已登录', 'click', '联系客服'])
      this.baiduTongji('联系客服')
      this.$nextTick(function() {
        // 原生js方法-设置滚动条高度到最下边
        var div = this.$refs.chatList;
        div.scrollTop = div.scrollHeight;
        // jquery方法-设置滚动条高度到最下边
        // $('.ivu-scroll-container').scrollTop( $('.ivu-scroll-container')[0].scrollHeight );
        console.log('this.isCreateEditor', this.isCreateEditor);

        if (this.isCreateEditor) {
          this.isCreateEditor = false;
          // 富文本编辑器的创建
          this.editor = new E("#edit-bar-" + this.openpage,"#edit-cont-" + this.openpage);
          // 自定义菜单配置
          console.log('this.editor', this.editor);

          this.editor.customConfig.menus = [
            'image',
          ]
          // this.editor.customConfig.onchange = (html) => {
          //     this.editorContent = html
          // }
          this.editor.customConfig.uploadImgServer = '/ws-truck/messenger/upload/image'   // 配置服务器端地址
          this.editor.customConfig.uploadImgHeaders = {
            'X-Requested-By': 'eshipping'
          }
          this.editor.customConfig.uploadFileName = 'file'
          this.editor.customConfig.uploadImgHooks = {
            error: function (xhr, editor) {
              _.ui.notify({
                message: "上传失败",
                type: 'error'
              });
            },
            timeout: function (xhr, editor) {
              _.ui.notify({
                message: "上传超时",
                type: 'error'
              });
            },
            customInsert: function (insertImg, result, editor) {
              var url = result.filePath

              insertImg(url)
            }
          }
          this.editor.customConfig.showLinkImg = false // 隐藏“网络图片”tab
          var that = this;
          this.editor.create();
        }
      });

    },
    showCard() {
      this.customerCard.show = !this.customerCard.show
    },
    // 往上滚动显示历史记录
    handleReachTop(event) {
      if (event.target.scrollTop < 5 && this.questionList.length < this.questionListTotal && this.isTurePage) {
        // console.log('total', this.questionListTotal);
        this.isTurePage = false;
        this.topCurPage++;
        var condition = {
          page: this.topCurPage,
          pageSize: this.questionListReq.pageSize
        }
        this.stranger ? condition.phone = this.stranger.mobilePhone : null
        // console.log('condition', condition);
        util.ajax_get(this, '/ws-truck/messenger/customer/posting/record', condition, response => {
          if (response.data.success) {
            response = eval('('+response.data.data.value+')');
            var scrollHeight = this.$refs.chatList.scrollHeight
            this.questionList = response.list.concat(this.questionList);
            this.$nextTick(function() {
              this.$refs.chatList.scrollTop = this.$refs.chatList.scrollHeight - scrollHeight;
              this.isTurePage = true;
            })
            console.log('list', this.questionList);
          }
        });
      }
    },
    checkEmpty(html) {
      var checkValue = html
          .replace(/\s+/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/<p><\/p>/g, "")
          .replace(/<p><br><\/p>/g, "");
      if (!checkValue) {
        return true
      }
    },
    // 获取并发送输入框中的内容
    getContent: function (event) {
      // debugger


      if(event && event.keyCode==13){
        event.returnValue = false;
      }
      console.log('this.user.id', this.user.id);
      console.log(Cookies.get("user"));
      console.log('this.stranger', this.stranger);

      if (!Cookies.get("user") && !this.stranger) {
        this.stranger ? null : this.visitorModal = true
        return
      }
      this.content = this.editor.txt.html()
      // 如果为空或者回车不能发送
      if (this.checkEmpty(this.content)) {
        this.$Message.error('不得发送空消息');
        this.$nextTick(() => {
          this.editor.txt.clear();
        });
        return;
      }
      var contentExt = this.content;
      var filePathList = [];
      // 提取字符串中网址
      var re=/(http:\/\/)?([A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*)/g;
      contentExt.replace(re,function(a){
        filePathList.push(a);
        // console.log('a',a)
      });
      // console.log('filelist', filePathList);
      this.content = this.translateEmoticon(this.content,'send').replace(/</g, "{").replace(/>/g, "}")
      // console.log('content', content);
      var condition = {
        content: this.content,
        filePathList: filePathList,
      };
      // let stranger = JSON.parse(window.sessionStorage.getItem('stranger'))
      console.log(this.stranger);
      // if (this.stranger && this.stranger.mobilePhone) {
      //   condition.phone = this.stranger.mobilePhone
      // }
      if (this.stranger && this.stranger.sendCode) {
        condition.token = this.stranger.sendCode
      }
      if (this.user.id) {
        condition.phone = ''
      }
      util.ajax_post(this, '/ws-truck/messenger/customer/posting/send', condition, response => {
        // console.log('res', response);
        if (response.data.success) {
          _hmt.push(['_trackEvent', '用户已登录', 'click', '发送信息'])
          this.content = ''
          console.log('发送后返回的',response)
//              console.log('response', response);
          this.autoReply()

        } else {
          if (response.data.code == 'UNAUTHORIZED') {
            this.$Message.error('验证信息已失效');
            sessionStorage.removeItem('stranger')
            this.visitorModal = true
          }
          console.log(response.data.message);
        }
      });
      // 初始化文本框中的内容
      this.editor.txt.clear();
    },
    autoReply(type) {
      var condition = {}
      console.log('this.stranger', this.stranger);

      if (this.stranger) {
        this.stranger.mobilePhone ? condition.customerId = this.stranger.mobilePhone : null
      }

      if (type == 'WELCOME') {
        condition.autoReplyType = type
      } else {
        condition.autoReplyType = 'CONTACT'
      }
      let time = 0
      condition.autoReplyType == 'CONTACT' ? time = 500 : time = 0

      util.ajax_post(this, '/ws-truck/duckBill/auto-reply/customer-posting', condition, response => {
        console.log('responseresponse', response);
        if (response.data.success) {
          this.getChatList();
          if (type == 'WELCOME') {
            setTimeout(() => {
              this.getContent()
            },time)
          }
        }
      })
    },
    // 获取文件名传给后端
    handleUpload (file) {
      var curArr = file.name.split('.');
      this.uploadInfo.fileType = "." + curArr[curArr.length - 1];
      // 获取文件名用于发送时传给后端
      this.uploadInfo.fileName = file.name;
      console.log('file', file);
      console.log('fileType', this.uploadInfo.fileType);
    },
    // 获取文件类型
    obtainFileType(string) {
      var curArr = string.split('.');
      var fileType = curArr[curArr.length-1].toUpperCase();
      return fileType;
    },
    // 验证上传文件格式
    formatError(file, fileList) {
      this.$Message.error('请选择文件上传');
    },
    // 上传成功
    uploadSuccess (response, file, fileList) {
      if (response && response.success) {
        // this.$Message.success('上传成功');
        var condition = {
          content: this.uploadInfo.fileName,
          filePath: response.filePath
        }
        if (this.stranger && this.stranger.mobilePhone) {
          condition.phone = this.stranger.mobilePhone
        }
        util.ajax_post(this, '/ws-truck/messenger/customer/posting/send', condition, response => {
          // console.log('res', response);
          if (response.data.success) {
            console.log('response', response);
            this.getChatList();
          } else {
            console.log(response.data.message);
          }
        });
        return;
      }
      this.$Message.error('上传失败');
    },
    analysisContent(val) {
      var ret = val.replace(/{/g, "<").replace(/}/g, ">").replaceAll('＂','')
      return this.translateEmoticon(ret,'received');
    },
    translateEmoticon(html,key) {
      if(this.checkEmpty(html)) return html
      if(key == 'received'){
        for(let k in this.emoticonsList){
          let img = '<img class="emoticon-bg ' + this.emoticonsList[k] + '" src="http://fastdfs.driverglobe.com/group1/M00/39/AB/Ch7o6lu8UaaAdqK1AAADnQzOWcQ374.jpg">'
          while(html.indexOf(k) != -1){
            html = html.replace(k,img)
          }
        }
        return html
      }else if(key == 'send'){
        for(let k in this.emoticonsList){
          let img = '<img class="emoticon-bg ' + this.emoticonsList[k] + '" src="http://fastdfs.driverglobe.com/group1/M00/39/AB/Ch7o6lu8UaaAdqK1AAADnQzOWcQ374.jpg">'
          while(html.indexOf(img) != -1){
            html = html.replace(img,k)
          }
        }
        return html
      }
    },
    // 查看图片大图
    showImg(e) {
      console.log('target', e.target.getAttribute('src'));
      var imgUrl = e.target.getAttribute('src');
      if (imgUrl) {
        this.imageViewerParams.recordImgs = [
          {
            imagePath: imgUrl.replaceAll('＂','')
          }
        ];
        this.lookPictureModel = true;
      }
      // console.log('kk')
    },
    // 下载文件
    downloadFile(file) {
      let url = window.location.origin + '/ws-truck/messenger/download/file?filePath=' + file.filePath + '&fileName=' + file.content;
      // window.open(url,'_black');
      window.location.href = url;
    },
    // 查看历史消息
    lookHistoryRecord() {
      _hmt.push(['_trackEvent', '用户已登录', 'click', '历史消息'])
      if (this.showChatRecord) {
        this.searchInput = '';
        this.getHistoryRecord();
      }
      this.showChatRecord = !this.showChatRecord;
    },
    // 点击tab标签
    clickTab(type) {
      console.log('type', type);
      /*if (this.curTabActive == type) {
          return;
      }*/
      this.curTabActive = type;
      // 初始化当前页
      this.historyPage.curPage = 1;
      switch (type) {
        case 'all':
          this.historyReq.page = 1
          this.getHistoryRecord();
          break;
        case 'picture':
          this.getPictureList();
          break;
        case 'file':
          this.getFileList();
          break;
      }
    },
    // 获取历史消息列表
    getHistoryRecord(type) {
      var condition = this.historyReq;
      // console.log('历史消息type', type)
      if (type) {
        condition.keyword = this.searchInput;
        condition.creationTimeFrom = this.sarchDate;
        this.curTabActive = 'all';
      } else {
        // 初始化搜索框内容
        condition.keyword = '';
        condition.creationTimeFrom = this.sarchDate;
      }
      this.allLoader = true;
      this.stranger ? condition.phone = this.stranger.mobilePhone : null
      util.ajax_get(this, '/ws-truck/messenger/customer/posting/record', condition, response => {
        if (response.data.success) {
          this.allLoader = false;
          response = eval('('+response.data.data.value+')');
          this.historyPage.total = response.total;
          this.histyQuestionList = response.list;
          this.$nextTick(function() {
            if (this.sarchDate == ""){
              $('.ivu-tabs-tabpane').scrollTop( $('.ivu-tabs-tabpane')[0].scrollHeight );
            }
          })
          console.log('list', this.histyQuestionList);
        }
      });
    },
    // 获取图片
    getPictureList() {
      // var condition = this.historyReq;
      // condition.searchType = 'IMAGE';
      // 总页数暂时置为1
      var that = this;
      this.historyPage.total = 1;
      this.allLoader = true;
      let condition = {
        searchType: 'IMAGE',
        creationTimeFrom:that.sarchDate
      }
      this.stranger ? condition.phone = this.stranger.mobilePhone : null
      util.ajax_get(this, '/ws-truck/messenger/customer/attachment/record', condition, response => {
        if (response.data.success) {
          this.allLoader = false;
          response = eval('('+response.data.data.value+')');
          for(var idx in response) {
            response[idx].date = response[idx].creationTime.split(' ')[0];
          }
          this.histyPictureList = this.arrangePicDate(response, 'date');
          console.log('response', this.histyPictureList);
        }
      });
    },
    // 图片列表按日期排序
    arrangePicDate(arr, key) {
      if (!arr.length) {
        return;
      }
      var _arr = [], _t = [], _tmp;
      _tmp = arr[0][key];
      // 将相同类别的对象添加到统一个数组
      for (var i in arr) {
        if ( arr[i][key] === _tmp ) {
          _t.push( arr[i] );
        } else {
          _tmp = arr[i][key];
          _arr.push( _t );
          _t = [arr[i]];
        }
      }
      // 将最后一组 push 到数组
      _arr.push( _t );
      return _arr;
    },
    // 处理时间格式
    handleTimeFormat(date) {
      if (!date) return;
      var dateList = date.split('-');
      return dateList[0]+"年"+dateList[1]+"月"+dateList[2]+"日";
    },
    // 只保留时间
    keepTime(date) {
      // console.log('datedatedate', date);

      if (!date) return;
      var time = date.slice(5, date.length);
      return time;
    },
    getFileList() {
      // var condition = this.historyReq;
      // condition.searchType = 'FILE';
      // 总页数暂时置为1
      this.historyPage.total = 1;
      this.allLoader = true;
      var that = this
      let condition = {
        searchType: 'FILE',
        creationTimeFrom:that.sarchDate
      }
      this.stranger ? condition.phone = this.stranger.mobilePhone : null
      util.ajax_get(this, '/ws-truck/messenger/customer/attachment/record', condition, response => {
        if (response.data.success) {
          this.allLoader = false;
          response = eval('('+response.data.data.value+')');
          for(var idx in response) {
            response[idx].date = response[idx].creationTime.split(' ')[0];
            response[idx].time = response[idx].creationTime.split(' ')[1];
          }
          this.histyFileList = this.arrangePicDate(response, 'date');
          console.log('response', this.histyFileList);
        }
      });
    },
    // 拿到当前页数
    getPage(page) {
      console.log('page', page);
      if (page) {
        this.historyPage.curPage = page;
        this.historyReq.page = page;
        this.getHistoryRecord();
      }
    },
    hideChatPop() {
      this.chatPop = true;
      this.onClose();
      this.$emit("hideContactService",true)
    },
    addEmoticon(val) {
      this.showEmoticon = false
      var img = '<img class="emoticon-bg ' + this.emoticonsList[val] + '" src="http://fastdfs.driverglobe.com/group1/M00/39/AB/Ch7o6lu8UaaAdqK1AAADnQzOWcQ374.jpg">'
      this.editor.cmd.do('insertHTML', img)
    },
    // 聊天-->
    // 打开咨询弹窗
    openConsultationModal() {
      // this.getDoorAreas();
      // _hmt.push(['_trackEvent', '用户未登录', 'click', '业务咨询'])
      this.baiduTongji('业务咨询')
      _hmt.push(['_trackPageview', '/pageConsult'])
      this.chatPop = true
      this.isConsultationModalVisible = true;
    },
    cancelImgModal() {
      this.isReadFlag = true;
      var indexReadIds = [];
      this.noticeModal.noticeSetting.data.forEach(v=>{
        indexReadIds.push(String(v.id))
      })
      if(this.noticeData == 'PC_INDEX' && !this.user.id) {
        Cookies.set("indexReadIds",indexReadIds,{expires: 7});
      }else {
        util.ajax_post(this,'/ws-truck/notice/readNotices',{noticeIds:indexReadIds},function(res) {
          if(!res.success) {
            console.log("关闭图片失败")
          }
        })
      }
      this.$emit('on-notice-toggle', false)
    },
    //打开弹窗了解更多
    openNewPage: function(e,url) {
      e.preventDefault();
      if(url) {
        window.open(url,'_blank')
      }
    },
    //轮播的右图点击
    moveRight: function() {
      $('.ivu-carousel-arrow.right').trigger("click");
    },
    //轮播的左图点击
    moveLeft: function() {
      $('.ivu-carousel-arrow.left').trigger("click");
    },
    //隐藏弹窗，查看公告按钮,气泡提示
    hideNoticeAll: function() {
      this.isCheckNotice = false;
      this.isShowNoticeTip = false;
      this.noticeModal.fade = false;
    },
    //请求轮播的展示数据
    showNotice: function(type,callback) {
      var that = this;
      this.noticeModal.noticeSetting.index = 0;
      this.noticeModal.noticeSetting.data = [];
      this.noticeModal.noticeSetting.rtImg = '';
      this.noticeModal.noticeSetting.lfImg = '';
      util.ajax_get(this,'/ws-truck/notice/getAllNoticePics', {useCaseId:type}, res => {
        console.log(res)
        var response = [];
        if(res.data.success){
          response = JSON.parse(res.data.data.value);
          if(response.length !=0) {
            that.isCheckNotice = true;
            response.forEach(function(v,index){
              if(Cookies.get("indexReadIds") && (Cookies.get("indexReadIds").indexOf(String(v.id))<0) && (that.noticeData == 'PC_INDEX') && !that.user.id) {
                that.isReadFlag = false
              }
              if((index == 0) && that.user.id) {
                console.log(v.isRead)
                that.isReadFlag = v.isRead;
              }
              that.noticeModal.noticeSetting.data.push({
                url: v.picUrl.split(';')[1],
                link: v.noticeUrl,
                id: v.id
              })
            })
            that.initActivity()
            if(callback) {
              callback()
            }
          }else {
            that.hideNoticeAll()
            // 此时为无公告 & 第一次，直接弹窗
            if (Cookies.get("firstHasNoticeOrder") !== 'yes' && !Cookies.get('COUPON_READ')) {
              this.$store.commit("coupon/showCouponModalIfHasCoupon", true)
            }
          }

        }else {
          that.hideNoticeAll()
        }
      },function(err){
        console.log(err)
        that.hideNoticeAll()
      });
    },
    //是否显示左右切换按钮
    isShowSwitchBtn: function() {
      this.$nextTick(function() {
        $('.ivu-carousel .left').css('visibility','hidden');
        $('.slide-lf').attr('src','')
        if(this.noticeModal.noticeSetting.data.length == 1) {
          $('.ivu-carousel .right').css('visibility','hidden');
          $('.slide-rt').attr('src','')
        }
      })
    },
    //初始化，轮播第一次只弹一次
    initActivity() {
      if(this.noticeModal.noticeSetting.data[this.noticeModal.noticeSetting.index+1]) {
        this.noticeModal.noticeSetting.rtImg = this.noticeModal.noticeSetting.data[this.noticeModal.noticeSetting.index+1]['url']
      }
      this.isShowSwitchBtn();
      if($('#home-link').length !=0) {
        if (Cookies.get("firstHasNoticeOrder") == 'yes') {
          return;
        }else {
          Cookies.set("firstHasNoticeOrder","yes",{expires: 1});
          this.$emit('on-notice-toggle', true) // 第一次展示
        }
      }else {
        if (Cookies.get("firstHasNoticeIndex") == 'yes') {
          return;
        }else {
          Cookies.set("firstHasNoticeIndex","yes",{expires: 1});
        }
      }
      // var millisecond = new Date().getTime();
      // var expiresTime = new Date(millisecond + 60 * 1000 * 2);
      // if (Cookies.get("firstHasNotice") == 'yes') return;
      // Cookies.set("firstHasNotice","yes",{expires: 1});
      this.isReadFlag = false;
      this.isShowNoticeTip = true;
      this.noticeModal.fade = true;
      this.isShowSwitchBtn();
    },
    //点击查看公告
    checkNotice: function() {
      var that = this;
      if(!this.isReqNotice) {
        return;
      }
      this.baiduTongji('查看公告')
      this.isReqNotice = false;
      this.showNotice(this.noticeData,function(){
        that.isReqNotice = true;
        that.noticeModal.fade = true;
      })
    },
    //轮播图点击
    changeNotice(oldValue,value) {
      var that = this;
      var slideCallback = function(isClear,className,imgCover,imgUrl) {
        if(isClear) {
          that.noticeModal.noticeSetting[imgCover] = '';
          that.$nextTick(function(){
            $('.'+className).attr('src','')
          })
        }else {
          that.noticeModal.noticeSetting[imgCover] = imgUrl
        }
      }
      //右滑动
      if((value == this.noticeModal.noticeSetting.data.length-1) && (oldValue < value)) {
        $('.ivu-carousel .right').css('visibility','hidden');
      }else {
        $('.ivu-carousel .right').css('visibility','visible');
      }
      // 左滑动
      if((value == 0) && (oldValue > value)) {
        $('.ivu-carousel .left').css('visibility','hidden');
      }else {
        $('.ivu-carousel .left').css('visibility','visible');
      }
      //右滑动
      if(oldValue < value) {
        if(value == this.noticeModal.noticeSetting.data.length-1) {
          slideCallback(true,'slide-rt','rtImg','')
        }else {
          slideCallback(false,'slide-rt','rtImg',this.noticeModal.noticeSetting.data[value+1]['url'])
        }
        if(value == 0) {
          slideCallback(true,'slide-lf','lfImg','')
        }else {
          slideCallback(false,'slide-lf','lfImg',this.noticeModal.noticeSetting.data[oldValue]['url'])
        }
      }
      // //左滑
      if(oldValue > value) {
        if(value == this.noticeModal.noticeSetting.data.length-1) {
          slideCallback(true,'slide-rt','rtImg','')
        }else {
          slideCallback(false,'slide-rt','rtImg',this.noticeModal.noticeSetting.data[oldValue]['url'])
        }
        if(value == 0) {
          slideCallback(true,'slide-lf','lfImg','')
        }else {
          slideCallback(false,'slide-lf','lfImg',this.noticeModal.noticeSetting.data[value-1]['url'])
        }
      }
    },
  }
}
</script>




// WEBPACK FOOTER //
// chat-pop.vue?7ca7fed2